import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'pages.settings.sections.spooler.title',
    defaultMessage: 'Spooler',
    description: 'title of the spooler section on the settings page',
  },
  subtitle: {
    id: 'pages.settings.sections.spooler.subtitle',
    defaultMessage: 'These settings are for this device only',
    description: 'subtitle of the spooler printers section on the settings page',
  },
  a4Printer: {
    title: {
      id: 'pages.settings.sections.spooler.a4Printer.title',
      defaultMessage: 'A4 printer',
      description: 'subtitle of the a4 printer list item',
    },
  },
  labelPrinter: {
    title: {
      id: 'pages.settings.sections.spooler.labelPrinter.title',
      defaultMessage: 'Label printer',
      description: 'subtitle of the label printer list item',
    },
  },
  barcodePrinter: {
    title: {
      id: 'pages.settings.sections.spooler.barcodePrinter.title',
      defaultMessage: 'Barcode printer',
      description: 'subtitle of the barcode printer list item',
    },
  },
  a4EditDrawer: {
    title: {
      id: 'pages.settings.sections.spooler.a4EditDrawer.title',
      defaultMessage: 'Edit A4 printer',
      description: 'title of the a4 printer edit drawer',
    },
    fields: {
      printer: {
        label: {
          id: 'pages.settings.sections.spooler.a4EditDrawer.fields.printer.label',
          defaultMessage: 'A4 printer',
          description: 'label of the printer field in the a4 printer edit drawer',
        },
      },
    },
  },
  labelEditDrawer: {
    title: {
      id: 'pages.settings.sections.spooler.labelEditDrawer.title',
      defaultMessage: 'Edit label printer',
      description: 'title of the label printer edit drawer',
    },
    fields: {
      printer: {
        label: {
          id: 'pages.settings.sections.spooler.labelEditDrawer.fields.printer.label',
          defaultMessage: 'Label printer',
          description: 'label of the printer field in the label edit drawer',
        },
      },
    },
  },
  barcodeEditDrawer: {
    title: {
      id: 'pages.settings.sections.spooler.barcodeEditDrawer.title',
      defaultMessage: 'Edit barcode printer',
      description: 'title of the barcode printer edit drawer',
    },
    fields: {
      printer: {
        label: {
          id: 'pages.settings.sections.spooler.barcodeEditDrawer.fields.printer.label',
          defaultMessage: 'Barcode printer',
          description: 'label of the printer field in the barcode edit drawer',
        },
      },
    },
  },
  feedback: {
    noPrinterSelected: {
      id: 'pages.settings.sections.spooler.feedback.noPrinterSelected',
      defaultMessage: 'no printer selected',
      description: 'feedback when no printer is selected',
    },
    printerSettingsSaved: {
      id: 'pages.settings.sections.spooler.feedback.printerSettingsSaved',
      defaultMessage: 'Spooler settings saved',
      description: 'feedback when the printer settings were saved',
    },
  },
  actions: {
    edit: {
      id: 'actions.edit',
      defaultMessage: 'Edit',
      description: 'label of the edit button',
    },
  },
};

export default defineMessages(translations);
